module.exports = __webpack_public_path__ + "img/dashboard_wip2.0a6fb265.png";